export default __webpack_public_path__ + "static/media/insta_dexpro4.313d7746.png";